import {FC, useRef} from 'react';
import useFilenameExtension from '../hooks/useFilenameExtension';
import useIsOverflowing from '../hooks/useIsOverflowing';
import TruncatorWrapper from '../TruncatorWrapper';
import {TruncatorProps} from '../types';

const TruncateLeft: FC<TruncatorProps> = ({
    className,
    showFilenameExtension = false,
    text: originalText,
}) => {
    const contentRef = useRef<HTMLDivElement | null>(null);
    const {isOverflowing} = useIsOverflowing(contentRef);

    const {suffix, text} = useFilenameExtension({
        showFilenameExtension,
        text: originalText,
    });

    return (
        <TruncatorWrapper
            className={className}
            message={isOverflowing ? text : ''}
        >
            <div
                ref={contentRef}
                className="overflow-hidden text-ellipsis"
                style={{direction: 'rtl'}}
            >
                {text}
            </div>
            {suffix && <span>{suffix}</span>}
        </TruncatorWrapper>
    );
};

export default TruncateLeft;
